import type { ListSort } from "./pagination.models";
import { sortSchema } from "./pagination.models";

/**
 * Columns the admin team search can be ordered by.
 *
 * The search serves one capped page, so the ordering decides which teams come back
 * and has to be resolved in the query rather than over the fetched rows.
 */
export const TEAM_SEARCH_SORT_KEYS = ["name", "slug", "createdAt"] as const;

export const teamSearchSortSchema = sortSchema(TEAM_SEARCH_SORT_KEYS);

export type TeamSearchSortKey = (typeof TEAM_SEARCH_SORT_KEYS)[number];
export type TeamSearchSort = ListSort<TeamSearchSortKey>;

/** Newest team first, matching every other admin list with a Created column. */
export const DEFAULT_TEAM_SEARCH_SORT: TeamSearchSort = {
  key: "createdAt",
  direction: "desc",
};
